export function getData() {
  return JSON.parse(localStorage.getItem('@VINILICO/theme:theme'));
}

export function setData(newData) {
  if (newData) localStorage.setItem('@VINILICO/theme:theme', JSON.stringify(newData)); // prettier-ignore
}
